import { Component, Input, OnInit } from '@angular/core';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedHttpService } from '../../services/shared-http.service';
import { CaseService } from '../../services/case.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-reasons',
  templateUrl: './reasons.component.html',
  styleUrls: ['./reasons.component.scss']
})
export class ReasonsComponent implements OnInit {
  caseReasonList: any;

  constructor(private modalService: NgbModal, public sharedService: SharedHttpService, public toastr: NotificationService, public caseService: CaseService) { }
  @Input() loadDataFP: Observable<any>;
  reasons: any = [];
  caseresons: any = "";
  caseObject: any;
  reason: any = "";
  showDeleteReasonButton = false;
  selectedReason;
  reasonId: any;
  reasonIdEdit: any;
  descriptionReasonEdit: any;
  reasoncaseEdit: any;
  casefacts: string = "";
  closeResult: string = '';




  ngOnInit(): void {
    this.loadDataFP.subscribe((data) => {
      setTimeout(() => {
        this.loadData();
      }, 100);

    });


  }



  loadData() {
    this.caseObject = this.caseService.getCaseData();


    this.sharedService.get(`api/Reason/GetAll?skip=0&take=1500`).subscribe(res => {
      this.reasons = res.data;
      this.reasons.map(reason => {
        if (this.caseresons.indexOf(reason.description) != -1) {
          reason.added = true;
        } else {
          reason.added = false;
        }
      })

    });
    this.caseresons = this.caseObject.reasons;
    if (this.caseresons == null) {
      this.caseresons = "";
    }


    this.sharedService.get(`api/CaseReason/GetAll?skip=0&take=1500&Filter.Filters[0].operator=eq&Filter.Filters[0].value=${this.caseObject.caseId}&Filter.Filters[0].field=caseId`).subscribe(res => {
      this.caseReasonList = res.data;
    });

  }

  clear() {
    this.caseresons = '';
    this.reason = '';
    this.modalService.dismissAll();

  }


  UpdateReason(item, mymodal) {

    console.log(item);
    this.reasonIdEdit = item.reasonId;
    this.descriptionReasonEdit = item.description;
    this.reasoncaseEdit = item.caseReasonId;
    this.reason = item.reasonId;
    this.sharedService.openLarge(mymodal);


  }

  reasonSelectedEdit(e) {
    console.log(e);
    console.log("ggg", this.reasons);

    this.reasonIdEdit = e.reasonId;
    this.reasons.map(r => {
      if (r.description == this.reason) {
        r.added = true;
      }
    })

    this.caseresons = this.reason;
    this.showDeleteReasonButton = true;
  }
  onUpdateReason() {
    let updateUrl = 'api/CaseReason/Update';
    let objectBody = { 'caseReasonId': this.reasoncaseEdit, 'reasonId': this.reasonIdEdit, 'description': this.descriptionReasonEdit, "caseId": this.caseObject.caseId };
    this.sharedService.put(updateUrl, [objectBody]
    ).subscribe((response) => {
      this.sharedService.showSuccessKey("EditedSuccessfully");
      this.modalService.dismissAll();
      this.loadData();
    },
      (error) => {
        console.error('error')
        this.sharedService.showErrorKey("Notsaved");
      });

  }



  DeleteReason(caseReasonId: any, mymodal) {
    this.openDel(mymodal);
    this.reasonId = caseReasonId;

  }

  openDel(content: any) {

    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;

    });
  }

  onDeleteReason() {
    let url = 'api/CaseReason/Delete'
    this.sharedService.delete(url, [this.reasonId]).subscribe(

      (response) => {
        this.sharedService.showSuccessKey("DeletedSuccessfully");
        this.modalService.dismissAll();
        this.loadData();
      },
      (error) => {
        console.error('error')
        this.sharedService.showSuccessKey("Notsaved");
      });
  }

  addReason(mymodal) {  
    this.reason=undefined;    
    this.sharedService.openLarge(mymodal);


}

onAddReason() {
    this.sharedService.post("api/CaseReason/Insert", [
        {
            "reasonId": this.selectedReason.reasonId,
            "description": this.caseresons,
            "caseId": this.caseObject.caseId
        }
    ]
    ).subscribe((response) => {
        this.sharedService.showSuccessKey("CreatedSuccessfully");
        this.modalService.dismissAll();
        this.loadData();
    },
        (error) => {
            console.error('error')
            this.sharedService.showErrorKey("Notsaved");


        });
}

private getDismissReason(reason: any): string {
  if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
  } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
  } else {
      return `with: ${reason}`;
  }
}

reasonSelected(e) {
  if (e) {
      this.selectedReason = e;          
}
this.reasons.map(r => {
  if (r.description == this.reason) {
      r.added = true;
  }
})
if (this.casefacts != "" && this.casefacts != null)
  this.caseresons = this.reason;
else
  this.caseresons =  this.reason;

}

saveFactsAndResons() {
  this.sharedService.post("api/Case/AddFactsAndResons", {
      // "facts": this.casefacts,
      "reasons": this.caseresons,
      // "suggestionDecision": this.SuggestionDecision,
      "caseId": this.caseObject.caseId
  }).subscribe((response) => {
      //this.caseObject = this.caseService.getCaseData();


      this.sharedService.get(`api/Case/GetCaseDetails?eCaseId=${this.caseObject.caseIdEncrypt}`).subscribe((res) => {
          console.log("CaseDetails", res);
          this.caseService.setCaseData(res);
      });

      this.sharedService.showSuccessKey("FactsAndResonsCreatedSuccessfully");
  },
      (error) => {
          console.error('error')
         this.sharedService.showErrorKey("Notsaved");
      });

}

}
